import { useUserSession } from '../../../models/hooks/appStateHooks';
import { CustomerImpersonationWarning } from '../../components/CustomerImpersonationWarning';
import { NavBar } from '../../components/Happiness/NavBar';
import { ManagedAccountAccessWarning } from '../../components/ManagedAccountAccessWarning';
import { AppDrawerPortalDestination } from '../Drawer/AppDrawer';
import { AppBar } from './components/AppBar';
import { AppBarGridArea, AppGrid, NavGridArea, PageRootGridArea, WarningGridArea } from './components/AppGrid/AppGrid';

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
	const userSession = useUserSession();
	return (
		<AppGrid>
			<NavGridArea>
				<NavBar />
			</NavGridArea>
			<WarningGridArea>
				<CustomerImpersonationWarning fixed={false} userSession={userSession} />
				<ManagedAccountAccessWarning fixed={false} userSession={userSession} />
			</WarningGridArea>
			<AppBarGridArea>
				<AppBar />
			</AppBarGridArea>
			<PageRootGridArea>{children}</PageRootGridArea>
			<AppDrawerPortalDestination />
		</AppGrid>
	);
};
